import type { Route } from 'vue-router';

interface AdServerDebuggerInfo {
	changesetID?: number;
	debug: boolean;
	dryRun: boolean;
}

// Debugger URL keys
const FORCE_CHANGESET_QUERY = 'change_id' as const;
const FORCE_DEBUG_QUERY = 'debug' as const;
const FORCE_DRY_RUN_QUERY = 'dry' as const;

/**
 * Reads adserver debugging overrides for the GetPlacement `testing` filter out of the url.
 *
 * ?change_id=344  preview a specific changeset
 * ?debug=true     return all viable ads instead of only the winning one
 * ?dry=true       don't let the request increment any adserver counters (i.e. impressions, clicks, etc.)
 *
 * A changeset - from here or from ADSERVER_CHANGESET_ID - is what puts a request into testing mode.
 * debug and dry only modify it. A testing request never counts unless ?dry=false says otherwise.
 */
export function getAdServerDebuggerInfo(query: Route['query']): AdServerDebuggerInfo {
	const debuggingInfo: AdServerDebuggerInfo = {
		debug: false,
		dryRun: true,
	};

	// Empty ?change_id= reads as NaN, not changeset 0
	const changesetID = Number(query[FORCE_CHANGESET_QUERY] || undefined);
	if (Number.isInteger(changesetID) && changesetID > 0) debuggingInfo.changesetID = changesetID;

	// Return all viable ads instead of only the winning one
	const debug = query[FORCE_DEBUG_QUERY];
	if (typeof debug === 'string') debuggingInfo.debug = debug === 'true';

	// Don't let the request increment any adserver counters
	const dryRun = query[FORCE_DRY_RUN_QUERY];
	if (typeof dryRun === 'string') debuggingInfo.dryRun = dryRun === 'true';

	return debuggingInfo;
}
